import React, { Component } from 'react';
import { isEmpty, find } from 'lodash';

import  {
    IconButton,
    FormHelperText,
    Grid,
    Box,
    Typography,
    Avatar,
    Alert,
} from '@mui/material';

import Currency from '../../common/Currency';
import { MONTHS } from '../../../utils/generalFuncs';
import Creatable from '../../common/Creatable';
import InputText from '../../common/Form';
import { CloseRounded } from '@mui/icons-material';


class DemandLineForm extends Component {
    state = { }

    handleChange = (e) => {
        const { name, value } = e.target;

        this.props.handleChange(name, value , this.props.index) 
    }

    handleChangeCreatable = (option, name) => {
        this.props.handleChangeCreatable(option, name, this.props.index)
    }
    deleteLine = (e) => {
        this.props.deleteLine(this.props.index)
    }

    render() {
        const { index, ARTICLES, demand, errors, selected} = this.props;
        let background = (index % 2 === 0) ? "" : "#f1f4f7";
        let article = this.props.demand_article ? find(ARTICLES, {article_id: this.props.demand_article}) : null
        console.log('====================================');
        console.log(article);
        console.log('====================================');
        return (
            <div>
                {index != 0 && <hr/> }
                <div style={{background, padding: "15px", marginBottom: "15px" }}>
                    <Box style={{display: "flex", alignItems:"center"}}>
                        <IconButton onClick={this.deleteLine}>
                            <CloseRounded color="error" />
                        </IconButton>
                        <Typography variant="button">Article {index + 1}</Typography>
                    </Box>
                     
                <Grid container>
                    <Grid item xs={12} sm={8} container style={{ alignItems: "center"}}>
                        {/* <Grid item sm={1} >
                        </Grid> */}
                        <Grid item md={10} xs={9}>
                            {/* <Box style={{display: "flex"}}> */}
                                {/* <IconButton onClick={this.deleteLine}>
                                    <CloseRounded color="error" />
                                </IconButton> */}
                                {ARTICLES &&
                                    <Creatable
                                        required
                                        error={errors.demand_article}
                                        label="Article"
                                        onChange={(option) => this.handleChangeCreatable(option, "demand_article")}
                                        name="demand_article" 
                                        id="demand_article"
                                        options={
                                            Object.values(ARTICLES).map( item => ({
                                                value: item.article_id, 
                                                label: `${item.article_name} | ${item.article_brand}`,
                                                disabled: selected.includes(item.article_id)
                                            }
                                        ))}
                                        helperText={article && article.article_desc}
                                        value={this.props.demand_articleDisplay || {value:"", label:""}}
                                    />

                                }
                            {/* </Box> */}
                        </Grid>

                        <Grid item md={2} xs={3}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="demand_quantity"
                                error={errors.demand_quantity}
                                value={this.props.demand_quantity}
                                name="demand_quantity"
                                label="Qté"
                                type="number"    
                                helperText={article && article.article_desc && " "}                          
                            />
                            
                        </Grid>
                        <Grid item xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                id="demand_remarks"
                                error={errors.demand_remarks}
                                value={this.props.demand_remarks}
                                name="demand_remarks"
                                label="Remarques"
                                multiline
                                // rows={2}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4} >
                        {!isEmpty(article) &&
                            <>
                                <Box style={{ textAlign: "center"}}>
                                    <img 
                                        style={{height: "150px"}}
                                        alt={article.article_name} 
                                        src={`/photos/single/${article.article_photo.filename}`} 
                                    />
                                </Box>
                                {article.article_remarks &&
                                    <Box>
                                        {/* <Alert severity="info">{article.article_desc}</Alert> <br/> */}
                                        <Alert severity="info">{article.article_remarks}</Alert>
                                    </Box>
                                }
                            </>
                        }
                    </Grid>
                </Grid>
                </div>                
            </div>
        );
    }
}


export default DemandLineForm 